/*------------------------------------*\
    MODULES
\*------------------------------------*/


/*------------------------------------*\
    SITE-HEAD
\*------------------------------------*/
class FaqAccordion {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.items = self.elem.querySelectorAll('[data-accordion-item]');
    }

    init() {
        let self = this;
        Array.from(self.items).map(item => {
            let trigger = item.querySelector('[data-accordion-trigger]');

            trigger.addEventListener('click', evt => {
                if (item.classList.contains('is-open')) {
                    item.classList.remove('is-open');
                    trigger.setAttribute('aria-expanded', false);
                } else {
                    item.classList.add('is-open');
                    trigger.setAttribute('aria-expanded', true);
                }
            });
        });
    }
    
}

export default FaqAccordion;
